import script from "./Communication.ts.vue?vue&type=script&lang=ts&setup=true"
export * from "./Communication.ts.vue?vue&type=script&lang=ts&setup=true"

import "./Communication.ts.vue?vue&type=style&index=0&id=cbbc2dbe&lang=scss"

const __exports__ = script;

export default __exports__